import type { FC, ReactNode } from 'react';
import { WebsiteJsonLd } from '@/base/WebsiteJsonLd';
import { Footer } from './Footer';
import { Header, type HeaderPosition } from './Header';

export const DefaultLayout: FC<{
  children?: ReactNode;
  hideFooter?: boolean;
  headerPosition?: HeaderPosition;
}> = ({ children, headerPosition = 'smart-sticky', hideFooter = false }) => (
  <>
    <WebsiteJsonLd />
    <Header position={headerPosition} />
    {children}
    {!hideFooter && <Footer />}
  </>
);
